import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import coreEn from '@modules/manifera-core/resources/js/languages/en'
import coreNl from '@modules/manifera-core/resources/js/languages/nl'
import LanguageDetector from 'i18next-browser-languagedetector'
import { i18nextPlugin } from 'translation-check'

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
void i18n
  .use(i18nextPlugin)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    supportedLngs: ['en', 'nl'],
    fallbackLng: 'nl',
    load: 'languageOnly',
    resources: {
      en: {
        translation: {
          ...coreEn
        }
      },
      nl: {
        translation: {
          ...coreNl
        }
      }
    },
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      convertDetectedLanguage: (lng: string) => lng.split('-')[0]
    }
  })

export default i18n
